import { Button, Modal } from "antd";
import React from "react";

export default function ModalConfirm({
  submitting,
  visible,
  onDisburse,
  dataForModalDisburse,
  onClose,
}) {
  return (
    <Modal
      title={"Anda Yakin Sudah Mencairkan Komisi?"}
      visible={visible}
      onCancel={onClose}
      width={500}
      centered
      footer={[
        <Button
          disabled={submitting}
          key="back"
          onClick={onClose}
          className="btn-modal btn-default"
          style={{ width: 100 }}
        >
          Kembali
        </Button>,
        <Button
          disabled={submitting}
          key="submit"
          type="primary"
          onClick={onDisburse}
          className="btn-modal"
          style={{ width: 100 }}
        >
          Yakin
        </Button>,
      ]}
    >
      <div className="mt-3">
        Anda telah mencairkan komisi untuk{" "}
        <span style={{ fontWeight: "700" }}>
          {dataForModalDisburse?.customerName}
        </span>
        . Konfirmasi kembali transaksi anda sebelum melanjutkan.
      </div>
    </Modal>
  );
}
